<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>
                    <template #title>
                        <h5 class="font-semibold m-0">مشاهده مشخصات کاربر</h5>
                    </template>

                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <a-spin />
                    </a-row>

                    <div v-else class="row">
                        <div class="col-md-12 my-2">
                            <div class="user-info-item user-image-item">
                                <label>تصویر</label>
                                <div class="user-image-wrap">
                                    <img
                                        v-if="info.image"
                                        :src="$root.image_concat(info.image)"
                                        alt="user image"
                                    />
                                    <div v-else class="user-image-placeholder">بدون تصویر</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>نام</label>
                                <div>{{ info.firstname || '-' }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>نام خانوادگی</label>
                                <div>{{ info.lastname || '-' }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>شماره تماس</label>
                                <div>{{ info.phone || '-' }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>کد ملی</label>
                                <div>{{ info.national_code || '-' }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>تاریخ تولد</label>
                                <div>{{ info.birthday || '-' }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>ایمیل</label>
                                <div>{{ info.email || '-' }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>نقش کاربر</label>
                                <div>{{ roleName }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>موجودی کیف پول</label>
                                <div>{{ $root.number_format(info.wallet) }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>موجودی تهاتری</label>
                                <div>{{ $root.number_format(info.barter) }}</div>
                            </div>
                        </div>
                        <div class="col-md-4 my-2">
                            <div class="user-info-item">
                                <label>سرمایه اولیه</label>
                                <div>{{ $root.number_format(info.investment) }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-11"></div>
                            <div class="col-md-1">
                                <router-link to="/users/list" class="btn btn-fill btn-outline-danger w-100">
                                    بازگشت
                                </router-link>
                            </div>
                        </div>
                    </div>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            info: {},
            roles: [],
        };
    },
    computed: {
        roleName() {
            const role = this.roles.find((item) => item.id == this.info.role_id);
            return role ? role.name : '-';
        },
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            let _this = this;
            this.$store.state.loading = true;

            await axios
                .get('/roles/all')
                .then(function(response) {
                    _this.roles = response.data;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });

            await axios
                .get('/users/single/' + this.$route.params.id)
                .then(function(response) {
                    _this.info = response.data;
                    _this.$store.state.loading = false;
                })
                .catch(function(err) {
                    _this.$store.state.loading = false;
                    _this.$root.handleAxiosError(err);
                });
        },
    },
};
</script>

<style scope>
.user-info-item {
    border: 1px solid #eef0f4;
    border-radius: 6px;
    padding: 12px 14px;
    min-height: 74px;
    background: #fff;
}

.user-info-item label {
    color: #8392ab;
    display: block;
    margin-bottom: 8px;
}

.user-image-item {
    min-height: auto;
}

.user-image-wrap {
    display: flex;
    justify-content: center;
}

.user-image-wrap img {
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #eef0f4;
}

.user-image-placeholder {
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 1px dashed #cfd7e6;
    color: #8392ab;
    background: #fafbfc;
}
</style>
